import {
    CREATE_SKU_MASTER_DETAILS_REQUEST,
    CREATE_SKU_MASTER_DETAILS_SUCCESS,
    CREATE_SKU_MASTER_DETAILS_FAILURE,
    DELETE_SKU_MASTER_DETAILS_REQUEST,
    DELETE_SKU_MASTER_DETAILS_SUCCESS,
    DELETE_SKU_MASTER_DETAILS_FAILURE,
    FETCH_SINGLE_SKU_MASTER_DETAILS_REQUEST,
    FETCH_SINGLE_SKU_MASTER_DETAILS_SUCCESS,
    FETCH_SINGLE_SKU_MASTER_DETAILS_FAILURE,
    FETCH_SKU_MASTER_DETAILS_REQUEST,
    FETCH_SKU_MASTER_DETAILS_SUCCESS,
    FETCH_SKU_MASTER_DETAILS_FAILURE,
    UPDATE_SKU_MASTER_DETAILS_REQUEST,
    UPDATE_SKU_MASTER_DETAILS_SUCCESS,
    UPDATE_SKU_MASTER_DETAILS_FAILURE,
    RESET_SKU_MASTER_DETAILS_INFO,
    CREATE_SKU_MASTER_DETAILS_FORM,
    UPDATE_SKU_MASTER_DETAILS_FORM,
    FETCH_SKU_MASTER_DETAILS_WITH_ID_SUCCESS,
    FETCH_SKU_MASTER_DETAILS_WITH_ID_REQUEST,
    FETCH_SKU_MASTER_DETAILS_WITH_ID_FAILURE
} from './skuMasterDetails.actionsType';

export const SKU_MASTER_DETAILS = 'skuMasterDetails';

let initialState = {
    loading: false,
    skuMasterDetails: [],
    skuMasterDetailsWithoutId: [],
    skuMasterDetailsForm: {},
    selectedState: {},
    errorMessage: ''
};

export let skuMasterDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_SKU_MASTER_DETAILS_REQUEST:
        case CREATE_SKU_MASTER_DETAILS_REQUEST:
        case UPDATE_SKU_MASTER_DETAILS_REQUEST:
        case FETCH_SINGLE_SKU_MASTER_DETAILS_REQUEST:
        case FETCH_SKU_MASTER_DETAILS_WITH_ID_REQUEST:
        case DELETE_SKU_MASTER_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_SKU_MASTER_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                skuMasterDetailsWithoutId: updatePayload
            };
        case FETCH_SKU_MASTER_DETAILS_WITH_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                skuMasterDetails: updatePayload
            };
        case CREATE_SKU_MASTER_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                skuMasterDetailsForm: {}
            };
        case UPDATE_SKU_MASTER_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                skuMasterDetailsForm: {}
            };
        case FETCH_SINGLE_SKU_MASTER_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                skuMasterDetailsForm: updatePayload
            };
        case DELETE_SKU_MASTER_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                skuMasterDetailsForm: {}
            };
        case RESET_SKU_MASTER_DETAILS_INFO:
            return {
                ...state,
                skuMasterDetailsForm: {}
            };
        case CREATE_SKU_MASTER_DETAILS_FORM:
        case UPDATE_SKU_MASTER_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                skuMasterDetailsForm: {
                    ...state.skuMasterDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_SKU_MASTER_DETAILS_FAILURE:
        case FETCH_SKU_MASTER_DETAILS_WITH_ID_FAILURE:
        case CREATE_SKU_MASTER_DETAILS_FAILURE:
        case UPDATE_SKU_MASTER_DETAILS_FAILURE:
        case FETCH_SINGLE_SKU_MASTER_DETAILS_FAILURE:
        case DELETE_SKU_MASTER_DETAILS_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
